import React from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Calendar, Clock, Store, Edit2, Check } from "lucide-react";

export default function AgendaModal({ open, onOpenChange, modoEdicao, formData, setFormData, onSalvar }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="modal-agendamento">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-slate-800">
            {modoEdicao ? (
              <>
                <Edit2 className="w-5 h-5 text-slate-600" />
                Editar Agendamento
              </>
            ) : (
              <>
                <Calendar className="w-5 h-5 text-emerald-600" />
                Novo Agendamento
              </>
            )}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="flex gap-3 p-3 bg-slate-50 rounded-lg border border-slate-200">
            <div className="flex items-center gap-2 text-sm text-slate-600">
              <Clock className="w-4 h-4" />
              <span className="font-medium">{formData.horario}</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-slate-600">
              <Store className="w-4 h-4" />
              <span className="font-medium">{formData.loja}</span>
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="nome" className="text-slate-700">Nome do Cliente</Label>
            <Input
              id="nome"
              value={formData.nome}
              onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
              placeholder="Nome completo do cliente"
              className="border-slate-200 focus:border-slate-400"
              data-testid="input-nome"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="telefone" className="text-slate-700">Telefone</Label>
              <Input
                id="telefone"
                value={formData.telefone}
                onChange={(e) => setFormData({ ...formData, telefone: e.target.value })}
                placeholder="(00) 00000-0000"
                className="border-slate-200 focus:border-slate-400"
                data-testid="input-telefone"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="idade" className="text-slate-700">Idade</Label>
              <Input
                id="idade"
                type="number"
                min="0"
                max="150"
                value={formData.idade}
                onChange={(e) => setFormData({ ...formData, idade: e.target.value })}
                placeholder="Anos"
                className="border-slate-200 focus:border-slate-400"
                data-testid="input-idade"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="observacoes" className="text-slate-700">Observações</Label>
            <Input
              id="observacoes"
              value={formData.observacoes}
              onChange={(e) => setFormData({ ...formData, observacoes: e.target.value })}
              placeholder="Observacoes adicionais"
              className="border-slate-200 focus:border-slate-400"
              data-testid="input-observacoes"
            />
          </div>
        </div>

        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="border-slate-200">
            Cancelar
          </Button>
          <Button onClick={onSalvar} className="bg-slate-900 hover:bg-slate-800" data-testid="btn-salvar-agendamento">
            <Check className="w-4 h-4 mr-1" />
            {modoEdicao ? "Atualizar" : "Agendar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
